import React from "react";
import { useUser } from "../UserContext"; // Adjust the import based on your context file
import { Navigate } from "react-router-dom";
import HomeBA from "./BA/HomeBA";
import HomeBrand from "./Brand/HomeBrand";
import HomeAgency from "./Agency/HomeAgency";
import HomeAccount from "./Account/HomeAccount";
import { UserData } from "../UserContext";

const HomeRouter: React.FC = () => {
  const { currentUser } = useUser() as { currentUser: UserData | null }; // Allow currentUser to be null

  // Check if currentUser is null
  if (!currentUser) {
    return <div>Please log in</div>; // Display message if no user is logged in
  }

  switch (currentUser.role) {
    case "BA":
      return <HomeBA />;
    case "Brand":
    case "Supplier":
      return <HomeBrand />;
    case "Agency":
      return <HomeAgency />;
    case "Account":
      return <HomeAccount />;
    case "Owner":
      return <HomeAccount />;
    default:
      return <Navigate to="/" />; // Redirect to a default route if role is not recognized
  }
};

export default HomeRouter;
